export function getSiteName(hostname) {
    const hostnamePart = hostname.replace('www.', '').split('.');
    // Checking userspace subdomain
    return hostnamePart[0] === 'us' ? hostnamePart[1] : hostnamePart[0];
}
